import * as React from 'react'
import { NavigationLink } from './useExtranetLinks'

export type NavigationBarContextState = {
  megaMenu: {
    isOpen: boolean
    routes: Array<NavigationLink>
  }
}

type NavigationBarContext = {
  state: NavigationBarContextState
  setState: React.Dispatch<React.SetStateAction<NavigationBarContextState>>
}
export const NavigationBarContext = React.createContext<NavigationBarContext>(
  {} as NavigationBarContext
)

export const useNavigationBar = () => {
  const { state, setState } = React.useContext(NavigationBarContext)

  const clearMegaMenu = React.useCallback(
    () => setState((s) => ({ ...s, megaMenu: { isOpen: false, routes: [] } })),
    [state]
  )

  const openMegaMenu = React.useCallback(
    (routeData: NavigationLink, depthIndex = 0) => {
      const newRoutes = () => {
        const [first, second] = [...state.megaMenu.routes]

        if (depthIndex === 1) return [first, routeData]
        if (depthIndex > 1) return [first, second, routeData]

        return [routeData]
      }

      return setState((s) => ({
        ...s,
        megaMenu: {
          isOpen: true,
          routes: newRoutes(),
        },
      }))
    },
    [state]
  )

  const removeLastMenu = React.useCallback(
    () =>
      setState((s) => {
        const copyRoutes = [...s.megaMenu.routes]
        copyRoutes.pop()

        return {
          ...s,
          megaMenu: {
            isOpen: true,
            routes: copyRoutes,
          },
        }
      }),
    [state]
  )

  return {
    clearMegaMenu,
    openMegaMenu,
    megaMenu: state.megaMenu,
    removeLastMenu,
  }
}
